const vatNumberRegexp =
  /^[A-Za-z]{2,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/;

export default vatNumberRegexp;
